import makeAsyncScriptLoader from 'react-async-script';

const callbackName = 'onloadcallback';
const recaptchaURL = `https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=explicit&hl=pt-BR`;

export default (globalName, Recaptcha, exposeFuncs) =>
  makeAsyncScriptLoader(Recaptcha, recaptchaURL, {
    callbackName,
    globalName,
    exposeFuncs
  });
